import React, { useEffect, useState } from "react";
import { appUrl, PLATFORM } from "@/lib/platform";

// Logo files are served from the app itself (frontend/public/brand/, see the
// README there). No third party CDN is involved.

// Horizontal lockup (icon + "HEDA PLYWOODS" wordmark side by side)
export const LOGO_HORIZONTAL = appUrl("/brand/logo.png");

// The workspace's own logo on the platform when it has one (announced by
// /help-widget.js with window.__hedaBrand and the "heda-brand" event).
function useBrandLogo() {
  const [logo, setLogo] = useState(() => (PLATFORM && window.__hedaBrand?.logo) || null);
  useEffect(() => {
    if (!PLATFORM) return undefined;
    const on = (e) => setLogo(e.detail?.logo || null);
    window.addEventListener("heda-brand", on);
    return () => window.removeEventListener("heda-brand", on);
  }, []);
  return logo;
}

// The header logo, linking home: the workspace logo on the platform, else Heda's.
export function Logo({ className = "h-9 sm:h-11" }) {
  const brand = useBrandLogo();
  return (
    <a href={appUrl("/")} className="inline-flex shrink-0 items-center" data-testid="brand-logo-link">
      <img
        src={brand || LOGO_HORIZONTAL}
        alt="Heda Plywoods"
        className={`w-auto object-contain mix-blend-multiply ${className}`}
      />
    </a>
  );
}

export default Logo;
